<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1" id="prf">T<span class="small">HE</span> P<span class="small">HILOSOPHY OF</span> P<span class="small">OPULAR</span> C<span class="small">ULTURE</span></h1>
<p class="nonindent">The books published in the Philosophy of Popular Culture series will illuminate and explore philosophical themes and ideas that occur in popular culture. The goal of this series is to demonstrate how philosophical inquiry has been reinvigorated by increased scholarly interest in the intersection of popular culture and philosophy, as well as to explore through philosophical analysis beloved modes of entertainment, such as movies, TV shows, and music. Philosophical concepts will be made accessible to the general reader through examples in popular culture. This series seeks to publish both established and emerging scholars who will engage a major area of popular culture for philosophical interpretation and examine the philosophical underpinnings of its themes. Eschewing ephemeral trends of philosophical and cultural theory, authors will establish and elaborate on connections between traditional philosophical ideas from important thinkers and the ever-expanding world of popular culture.</p>
<p class="extract"><em>Series Editor</em></p>
<p class="extract">Mark T. Conard, Marymount Manhattan College, NY</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172309_epub_prf_r1.vue?84a77836